import productGetters from './productGetters';
import type { LineItem, Order } from '~/types/GraphQL';

export default {
  getDate: (order: Order | undefined) => order?.completedAt ?? order?.createdAt ?? '',
  getShippingTrackingURL: (order: Order | undefined) =>
    (order?.shippingInfo?.deliveries?.[0]?.parcels?.[0] as any)?.custom?.customFieldsRaw?.find(
      ({ name }) => name === 'trackingUrl',
    )?.value,
  getShippingDescription: (order: Order | undefined) =>
    order?.shippingInfo?.shippingMethod?.localizedDescription ?? order?.shippingInfo?.shippingMethodName,
  getFormattedPrice: productGetters.getFormattedPrice,
  getPrice: (order: Order | undefined) => order?.totalPrice?.centAmount / 100,
  getStatus: (order: Order | undefined) => order?.orderState,
  getId: (order: Order | undefined) => order?.id,
  getItems: (order: Order | undefined) => order?.lineItems,
  getItemSku: (item: LineItem) => item?.variant?.sku,
  getImages: (order: Order) => order?.lineItems?.map(i => i.variant?.images[0]?.url),
  getFirstImage: (order: Order) => order?.lineItems[0].variant?.images[0].url,
  getNames: (order: Order) => order?.lineItems?.map(n => n.name),
  getProductCount: (order: Order) => order?.lineItems?.length,
};
